import { ArrowRight } from '@phosphor-icons/react';
import { Heading, Inline, Stack } from '@etg/wings';
import { css } from '@eti/styles';

const wrapperStyles = css`
  font-size: 0.875rem;

  & svg {
    [dir='rtl'] & {
      transform: rotate(180deg);
    }
  }
`;
interface InfoBoxProps {
  link: string;
  linkLabel: string;
  text: string;
  title: string;
}

const InfoBox = ({ link, linkLabel, text, title }: InfoBoxProps) => {
  return (
    <div className={wrapperStyles}>
      <Stack spacing={8}>
        <Heading as="h2" level={3}>
          {title}
        </Heading>
        <Stack spacing={16}>
          <p>{text}</p>
          <a href={link} rel="noreferrer" target="_blank">
            <Inline alignY="center" as="span" noWrap spacing={8}>
              <span>{linkLabel}</span>
              <ArrowRight aria-hidden size={20} weight="light" />
            </Inline>
          </a>
        </Stack>
      </Stack>
    </div>
  );
};

export default InfoBox;
